import { useEffect, useState } from "react";
import { AlertsHooksMapping } from "../../../../../hooks/AlertsHooksMapping";
import AntdTable from "../../../../antd/Table/Table";

export default function AlertTable({
  title,
  limit,
  query,
  setLimit,
  setQuery,
  columns,
  sort,
  handleTableChange,
}) {
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    return () => {
      setLimit(10);
      setQuery("");
      localStorage.setItem("page", 1);
    };
  }, [setLimit, setQuery]);

  let data = [];
  let totalItems = 0;

  const alertHook = AlertsHooksMapping[title];

  if (!alertHook) return <div>{`No API found for ${title}`}</div>;

  const { data: apiData, isLoading } = alertHook({
    page: currentPage,
    limit: limit,
    search: query,
    sortBy: sort.by,
    sortOrder: sort.order,
  });

  data = apiData?.alerts || [];
  totalItems = apiData?.totalCount || 0;

  return (
    <div className="mt-3 table-parent">
      <AntdTable
        columns={columns}
        dataSource={data}
        loading={isLoading}
        pageSize={limit}
        totalItems={totalItems}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
        onLimitChange={(newLimit) => {
          setLimit(newLimit);
          setCurrentPage(1);
        }}
        scrollY={300}
        onTableChange={handleTableChange}
      />
    </div>
  );
}
